import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";

const FilterValuesQuery = graphql(`
  query GetFilterValues($filterName: String!) {
    filterValues(filterName: $filterName) {
      filterName
      values {
        key
        label {
          locale
          value
        }
      }
    }
  }
`);

export function useFilterValues(filterName: string | null) {
  const [result] = useQuery({
    query: FilterValuesQuery,
    variables: { filterName: filterName ?? "" },
    pause: !filterName,
    requestPolicy: "cache-first",
  });

  const { data, fetching: isFetching } = result;
  const isPending = isFetching && !data;

  const values = useMemo(() => data?.filterValues?.values ?? [], [data]);

  return { values, isPending };
}
